import { getOWAConnectedAccount } from '../selectors';

/***
 * Function that checks whether the email address belongs to the connected account
 */
export function isConnectedAccount(emailAddress: string): boolean {
    const account = getOWAConnectedAccount(emailAddress);
    return account !== undefined;
}
